import { ref, onMounted, onUnmounted } from 'vue';


/**
 * Composable for managing consent states and loading tracking scripts
 * Handles Outbrain and Taboola consent via Usercentrics
 */
export function useConsentHelper() {
  // Reactive consent state
  const outbrainAllowed = ref(false);
  const taboolaAllowed = ref(false);
  const loadedScripts = ref(new Set());

  /**
   * Initialize consent state from UC_UI on component mount
   * Checks existing consent from cookies/previous sessions
   */
  const initializeConsentState = (event_data) => {
      console.log('initializeConsentState', event_data);

      outbrainAllowed.value = event_data.detail && event_data.detail['Outbrain Amplify'];
  };


  /**
   * Load Outbrain tracking script for a specific account ID
   * @param {string} accountId - Outbrain account/marketer ID
   */
  const loadOutbrainScript = (accountId) => {
    // Prevent duplicate loading
    if (loadedScripts.value.has(accountId)) {
      console.log(`Outbrain script already loaded for account: ${accountId}`);
      return;
    }

    try {
      // Create script element
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      console.log('loadoutbrain')

      // Outbrain initialization code with PAGE_VIEW tracking
      script.textContent = `
        !function(_window, _document) {
          var OB_ADV_ID = '${accountId}';
          if (_window.obApi) {
            var toArray = function(object) {
              return Object.prototype.toString.call(object) === '[object Array]' ? object : [object];
            };
            _window.obApi.marketerId = toArray(_window.obApi.marketerId).concat(toArray(OB_ADV_ID));
            return;
          }
          var api = _window.obApi = function() {
            api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments);
          };
          api.version = '1.1';
          api.loaded = true;
          api.marketerId = OB_ADV_ID;
          api.queue = [];
          var tag = _document.createElement('script');
          tag.async = true;
          tag.src = '//amplify.outbrain.com/cp/obtp.js';
          tag.type = 'text/javascript';
          var script = _document.getElementsByTagName('script')[0];
          script.parentNode.insertBefore(tag, script);
        }(window, document);

        obApi('track', 'PAGE_VIEW');
      `;

      document.head.appendChild(script);
      loadedScripts.value.add(accountId);
      console.log(`Outbrain script loaded for account: ${accountId}`);
    } catch (error) {
      console.error(`Error loading Outbrain script for account ${accountId}:`, error);
    }
  };

  /**
   * Load Taboola tracking script for a specific account ID
   * @param {string} accountId - Taboola account ID
   */
  const loadTaboolaScript = (accountId) => {
    console.log('Taboola script loading not yet implemented');
    // TODO: Implement when Taboola account IDs are added to config
  };





  const sendEvent = (eventName, eventValue) => {
      console.log('sendEvent', eventName, eventValue);

      try {
          window.obApi('track', eventName, eventValue);
      }catch(e){
          console.warn('sendEvent', 'Outbrain not loaded yet', e);
      }

  }

    window.addEventListener('usercentric_consent_v2', initializeConsentState);

  // Return public API
  return {
    // Reactive consent states
    outbrainAllowed,
    taboolaAllowed,
    sendEvent,
    // Script loading methods
    loadOutbrainScript,
    loadTaboolaScript,
  };
}
